module.exports = "https://www.gc-qa.gnp.com.mx/ad2acae50db8ad030a0911ab551e35b9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons-gnp/logo_vivir_increible.svg
// module id = 1847
// module chunks = 0